import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class DownloadButtonComponent {
  @Input() color = 'download';
  @Input() callToAction = '';
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' = 'button';
  @Output() Click: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  handleClick(e: MouseEvent): void {
    this.Click.emit(e);
  }
}
